<template>
    <div class="carManage-box">
        <HeaderNav
            header-title="考勤打卡"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="clock-con">
            <div class="header" @click="toTimeKeeping">
                <div class="header-info">
                    <span class="head-icon">{{ Name|headerPortFilter }}</span>
                    <div class="name">
                        <h4>{{ Name }}</h4>
                        <div>{{ RoleNames }}</div>
                    </div>
                    <div class="time">
                        <span>{{ currentDate }}</span>
                        <span class="iconfont iconfanhui1"></span>
                    </div>
                </div>
                <div class="bind-status">
                    <div class="status-item" v-if="!isBind">
                        <span class="no-bind">
                            未绑定车辆
                        </span>
                    </div>
                    <div class="status-item" v-else>
                        <span class="binded">
                            已绑定车辆
                        </span>
                        <span class="car_license" v-if="car_license">
                            {{ car_license }}
                        </span>
                        <span class="car_no" v-if="car_no">
                            {{ car_no }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="body">
                <van-steps direction="vertical" :active="stepsActive" active-color="#3495FB">
                    <template v-if="!attendanceList">
                        <van-step>
                            <template #active-icon>
                                <span class="iconfont iconyuandianxiao blue"></span>
                            </template>
                            <template #inactive-icon>
                                <span class="iconfont iconyuandianxiao"></span>
                            </template>
                            <h3>上班打卡</h3>
                        </van-step>
                    </template>
                    <template v-else>
                        <van-step v-for="(item, index) in attendanceList" :key="index">
                            <template #active-icon>
                                <span class="iconfont iconyuandianxiao blue"></span>
                            </template>
                            <template #inactive-icon>
                                <span class="iconfont iconyuandianxiao"></span>
                            </template>
                            <h3>{{ item.type===0?'上班打卡': '下班打卡' }} </h3>
                            <p class="time">
                                <span class="iconfont iconshijian"></span>
                                <span class="info">打卡时间 {{ item.created }}</span>
                            </p>
                            <p class="address" @click="toAddress(item)">
                                <span class="iconfont iconweizhi1"></span>
                                <span class="info">{{ item.address }}</span>
                            </p>
                        </van-step>
                    </template>
                </van-steps>
                <div class="bind-car" @click="scanPcbNumber">
                    <div class="ball-box">
                        <span class="ball">
                            <h4>{{ btnText }}</h4>
                            <p>{{ currentTime }}</p>
                        </span>
                    </div>
                    <p class="tip">
                        点击按钮扫一扫，{{ btnText }}
                    </p>
                </div>
            </div>
            <!-- <div class="footer">
                <van-tabbar v-model="active" active-color="#FA4634" inactive-color="#979EA7">
                    <van-tabbar-item to="/carManage">
                        <span>打卡</span>
                        <template #icon="props">
                            <span :class="props.active ? 'iconfont icondaka active' : 'iconfont icondaka'"></span>
                        </template>
                    </van-tabbar-item>
                    <van-tabbar-item to="/timeKeeping">
                        <span>统计</span>
                        <template #icon="props">
                            <span :class="props.active ? 'iconfont icontongji1 active' : 'iconfont icontongji1'"></span>
                        </template>
                    </van-tabbar-item>
                </van-tabbar>
            </div> -->
        </div>
        <van-dialog v-model="showDialog" confirm-button-text="我知道了" confirm-button-color="#3495FB">
            <div class="dialog-con">
                <img src="./../../../assets/images/home_sj/bound.png">
                <div class="dialog-info">
                    <p>{{ handleTime }}</p>
                    <p>{{ handleTip }}</p>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast, Dialog } from 'vant';
import utils from '@/assets/js/utils';
export default {
    components: { HeaderNav },
    props: {},
    data() {
        return {
            active: 0, // 底部选项卡选中index
            stepsActive: 1, // 步骤条选中
            showDialog: false, // 绑定、解绑提示
            Name: '', // 用户名
            RoleNames: '', // 用户角色
            currentDate: '', // 当天
            currentTime: '', // 当前时间
            attendanceList: null, // 打卡记录列表
            btnText: '绑定车辆', // 打卡按钮文案
            handleType: 'bind', // 绑定、解绑
            handleTime: '', // 绑定成功、失败时间
            handleTip: '', // 操作成功提示文字
            isBind: false,
            car_license: '',
            car_no: '',
        };
    },
    watch: {},
    computed: {},
    filters: {
        headerPortFilter(value) {
            let str = '';
            if (value) {
                str = value.substr(value.length - 1, 1);
            }
            return str;
        },
    },
    methods: {
        // 跳转到打卡月历
        toTimeKeeping() {
            this.$router.push({ name: 'calendar' });
        },
        // 弹出绑定成功提示
        bindCar() {
            this.showDialog = true;
        },
        // 扫码
        scanPcbNumber() {
            if (this.handleType === 'unbind') {
                Dialog.confirm({
                    title: '提示',
                    message: '您是否解绑车辆信息？',
                })
                    .then(() => {
                        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                            const data = {
                                address: 'cs',
                                latitude: '111',
                                longitude: '111',
                            };
                            this.handleUnBindCar(data);
                        } else {
                            this.$callMobile('JYExternalNative', 'jyDriverUntieVehicleEvent');
                        }
                    })
                    .catch(() => {
                    // on cancel
                    });

            } else {
                this.$callMobile('JYExternalNative', 'jyDriveScanClick');
            }
        },
        jyCallback_DriverUntieVehicle(data) {
            const dataParse = JSON.parse(data);
            this.handleUnBindCar(dataParse);
        },
        // 解绑车辆
        handleUnBindCar(dataParse) {
            const data = {
                driver_phone: this.$takeTokenParameters('MobilePhone'),
                car_license: this.car_license,
                address: dataParse.address || 'cs',
                longitude: dataParse.longitude || '111',
                latitude: dataParse.latitude || '111',
            };
            this.$axios
                .post('/interfaceApi/logistics/attendance_manager/check_out', data)
                .then(res => {
                    if (res) {
                        this.handleTime = utils.currentTimeFormat('yyyy-MM-dd HH:mm:ss').split(' ')[1];
                        this.handleTip = '车辆解绑成功';
                        this.showDialog = true;
                        this.getAttendance();
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 扫码调用原生后的回调
        jyCallback_DriveScanFinished(sandata) {
            const dataParse = JSON.parse(sandata);
            const data = {
                driver_phone: this.$takeTokenParameters('MobilePhone'),
                car_license: dataParse.carNumber,
                address: dataParse.address,
                longitude: dataParse.longitude,
                latitude: dataParse.latitude,
            };
            let url = '';
            url = '/interfaceApi/logistics/attendance_manager/check_in';
            this.$axios
                .post(url, data)
                .then(res => {
                    if (res) {
                        this.handleTime = utils.currentTimeFormat('yyyy-MM-dd HH:mm:ss').split(' ')[1];
                        this.handleTip = '车辆绑定成功';
                        this.showDialog = true;
                        this.getAttendance();
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 查询打卡记录
        getAttendance() {
            this.$axios
                .get('/interfaceApi/logistics/attendance_manager/get_attendance/' + this.currentDate + '/0')
                .then(res => {
                    if (res.list) {
                        this.attendanceList = res.list;
                        const lastAttendance = res.list[res.list.length - 1];
                        this.stepsActive = res.list.length - 1;
                        if (lastAttendance.type === 0) {
                            this.handleType = 'unbind';
                            this.btnText = '解绑车辆';
                        } else {
                            this.handleType = 'bind';
                            this.btnText = '绑定车辆';
                        }
                    } else {
                        this.attendanceList = null;
                        this.btnText = '绑定车辆';
                        this.handleType = 'bind';
                    }
                    // if (res.is_bind) {
                    this.isBind = res.is_bind;
                    // }
                    if (res.car_license) {
                        this.car_license = res.car_license;
                    }
                    if (res.car_no) {
                        this.car_no = res.car_no;
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 查看定位
        toAddress(data) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'clockInAddress', params: { address: data.address, longitude: data.longitude, latitude: data.latitude } });
        },
    },
    created() {
        this.Name = this.$takeTokenParameters('Name');
        this.RoleNames = this.$takeTokenParameters('RoleNames');
        this.currentDate = utils.currentTimeFormat('yyyy-MM-dd HH:mm:ss').split(' ')[0];
        this.currentTime = utils.currentTimeFormat('yyyy-MM-dd HH:mm:ss').split(' ')[1];
        setInterval(() => {
            this.currentTime = utils.currentTimeFormat('yyyy-MM-dd HH:mm:ss').split(' ')[1];
        }, 1000);
        this.getAttendance();
    },
    mounted() {
        // 转发原生回调函数
        window.jyCallback_DriveScanFinished = this.jyCallback_DriveScanFinished;
        window.jyCallback_DriverUntieVehicle = this.jyCallback_DriverUntieVehicle;
    },
};
</script>
<style lang="stylus">
.carManage-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    display flex
    flex-direction column
    .dialog-con
        img
            width 100%
            margin-top 20rpx
        .dialog-info
            text-align center
            margin 10rpx 0
            color #3495FB
            p
                line-height 50rpx
                &:first-child
                    font-size 40rpx
    .clock-con
        height 100%
        .header
            height 100rpx
            padding 15rpx
            border-bottom 1px solid #F0F0F0
            .header-info
                display flex
                justify-content space-between
                .head-icon
                    width 40rpx
                    height 40rpx
                    border-radius 50%
                    background-color #3495FB
                    display inline-block
                    text-align center
                    line-height 40rpx
                    color #fff
                    flex none
                .name
                    flex 0 0 50%
                    h4
                        font-size 16rpx
                    div
                        font-size 14rpx
                        color #979EA7
                .time
                    flex none
                    font-size 14rpx
                    color #979EA7
                    line-height 32rpx
                    .iconfont
                        font-size 14rpx
                        margin-left 5rpx
            .bind-status
                font-size 14rpx
                .status-item
                    margin-top 8rpx
                .no-bind
                    background:linear-gradient(90deg,rgba(182,183,185,1),rgba(221,222,223,1));
                    padding 3rpx 6rpx
                    color #fff
                    display inline-block
                    line-height 22rpx
                .binded
                    background:linear-gradient(90deg,rgba(254,105,43,1),rgba(253,163,40,1));
                    padding 3rpx 6rpx
                    color #fff
                    display inline-block
                    margin-right 10rpx
                    line-height 22rpx
                .car_license
                    background:linear-gradient(90deg,rgba(17,173,255,1),rgba(56,187,255,1));
                    padding 3rpx 6rpx
                    color #fff
                    display inline-block
                    margin-right 10rpx
                    line-height 22rpx
                .car_no
                    background:linear-gradient(90deg,rgba(95,189,25,1),rgba(159,211,48,1));
                    padding 3rpx 6rpx
                    color #fff
                    display inline-block
                    line-height 22rpx
        .body
            flex 1
            height calc(100% - 100rpx)
            position relative
            .van-steps
                height calc(100% - 195rpx)
                overflow-y auto
                overflow-x hidden
            .iconyuandianxiao
                font-size 20rpx
                color #979EA7
                &.blue
                    color #3495FB
            .van-step--vertical
                .van-step__line
                    left -16rpx
                    background #E5E9F2!important
            .van-step--finish
                color #969799
            .van-step__title--active
                h3
                    color #969799!important
                p
                    color #969799!important
                    line-height 30rpx
                    .iconfont
                        font-size 14rpx
                        margin-right 5rpx
                        &.icondingwei_bendi
                            font-size 18rpx
                    .info
                        color #333333!important
            .van-step__title
                h3
                    font-size 12rpx
                    color #969799!important
                p
                    color #969799!important
                    line-height 30rpx
                    font-size 14rpx
                    .iconfont
                        font-size 14rpx
                        margin-right 8rpx
                        &.icondingwei_bendi
                            font-size 18rpx
                    .info
                        color #333333!important
                    &.address
                        margin-bottom 20rpx
                    &.time
                        margin-top 10rpx
            .bind-car
                text-align center
                padding 20rpx 0
                height 195rpx
                width 100%
                position absolute
                bottom 0
                left 0
                .ball-box
                    .ball
                        width 120rpx
                        height 120rpx
                        background linear-gradient(0deg,rgba(52,149,251,1),rgba(100,178,251,1))
                        box-shadow 0px 6px 32px 0px rgba(0,89,183,0.35)
                        border-radius 50%
                        display inline-block
                        color #fff
                        h4
                            font-size 18rpx
                            margin-top 40rpx
                            font-weight normal
                        p
                            color #BDDDFE
                .tip
                    font-size 10rpx
                    margin-top 20rpx

        .footer
            flex 1
            height 50rpx
            border-top 1px solid #F0F0F0
</style>